import { render, staticRenderFns } from "./newAdd.vue?vue&type=template&id=2fb9281c&scoped=true"
import script from "./newAdd.vue?vue&type=script&lang=js"
export * from "./newAdd.vue?vue&type=script&lang=js"
import style0 from "./newAdd.vue?vue&type=style&index=0&id=2fb9281c&prod&scoped=true&lang=less"
import style1 from "./newAdd.vue?vue&type=style&index=1&id=2fb9281c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb9281c",
  null
  
)

export default component.exports